import { __rest } from "tslib";
import * as React from 'react';
import { useGeneratedId } from '../../hooks';
import { ClassNames } from '../../utils';
/** Incredibly simple component designed to take some of the boilerplate out of making some elements appear in a row */
export const Group = React.forwardRef((_a, forwardedRef) => {
    var { children, className, title, id: htmlId } = _a, htmlProps = __rest(_a, ["children", "className", "title", "id"]);
    const id = useGeneratedId('arm-grp', htmlId);
    const labelId = title && `${id}_label`;
    return (React.createElement("div", Object.assign({ className: ClassNames.concat('arm-group', className) }, htmlProps, { ref: forwardedRef, "data-has-title": !!title, id: id, "aria-labelledby": labelId }),
        title && (React.createElement("p", { className: "arm-group-title", id: labelId }, title)),
        React.createElement("div", { className: "arm-group-inner" }, children)));
});
